module.exports = __webpack_public_path__ + "media/Instruction_03.d7dbc20a.mp3";